import {
  GridColDef,
  GridInitialState,
  GridRenderCellParams,
} from "@mui/x-data-grid-premium";
import React, { useEffect, useState } from "react";
import useApi from "../../../hooks/useGaneshApi";
import { getDateValue, renderDateCell, renderNumberCell } from "utils/dataGrid";
import GaneshDataGrid from "../../DataGrid/GaneshDataGrid";
import { BrandTasks_T } from "../../../types/Brand";
import { useError } from "../../../contexts/ErrorContext";
import { Link } from "react-router-dom";

const defaultGridState: GridInitialState = {
  filter: {
    filterModel: {
      items: [],
    },
  },
  sorting: { sortModel: [{ field: "brand_id", sort: "asc" }] },
  pagination: { paginationModel: { pageSize: 50, page: 0 } },
  pinnedColumns: { left: [] },
  columns: { columnVisibilityModel: {} },
  density: "compact",
};

const columns_def: GridColDef[] = [
  {
    field: "brand",
    headerName: "Brand",
    width: 200,
    renderCell: (params: GridRenderCellParams) => (
      <Link to={`/data-ops/brand/${params.row.brand_id}`}>{params.value}</Link>
    ),
  },
  {
    field: "brand_id",
    headerName: "Brand ID",
    width: 120,
  },
  {
    field: "brand_key",
    headerName: "Brand Key",
    width: 150,
  },
  {
    field: "country_code",
    headerName: "Country",
    width: 100,
  },
  {
    field: "query_execution_date",
    headerName: "Query Execution Date",
    width: 200,
    type: "date",
    valueGetter: getDateValue,
    renderCell: renderDateCell,
  },
  {
    field: "ready_for_review",
    headerName: "Ready for Review",
    width: 150,
  },
  {
    field: "task_display_name",
    headerName: "Task",
    width: 150,
  },
  {
    field: "status_type_display_name",
    headerName: "Status",
    width: 150,
  },
  {
    field: "assigned_to",
    headerName: "Assigned To",
    width: 200,
  },
  {
    field: "assigned_date",
    headerName: "Assigned Date",
    width: 150,
    type: "date",
    valueGetter: getDateValue,
    renderCell: renderDateCell,
  },
  {
    field: "completed_at",
    headerName: "Completed At",
    width: 150,
    type: "date",
    valueGetter: getDateValue,
    renderCell: renderDateCell,
  },
  {
    field: "created_by",
    headerName: "Created By",
    width: 150,
  },
  {
    field: "notes",
    headerName: "Notes",
    width: 150,
  },
];

const BrandsPlacesTasksTable: React.FC<any> = () => {
  const [brandsPlacesTasksData, setBrandsPlacesTasksData] = useState<
    BrandTasks_T[]
  >([]);
  const [loading, setLoading] = useState(true);

  const { showError } = useError();
  const { apiRequest } = useApi();

  useEffect(() => {
    const fetchBrandsPlacesTasks = async () => {
      try {
        const response = await apiRequest<BrandTasks_T[]>(
          `/tasks_reports/brands_places_tasks`,
          { method: "GET" }
        );
        if (response.data) {
          setBrandsPlacesTasksData(response.data);
        }
      } catch (error) {
        console.error(error);
        showError(`Failed to fetch brand places tasks.`);
      } finally {
        setLoading(false);
      }
    };

    fetchBrandsPlacesTasks();
  }, []);

  return (
    <GaneshDataGrid
      loading={loading}
      data={brandsPlacesTasksData}
      columns={columns_def}
      gridId="brands-places-tasks-table"
      defaultGridState={defaultGridState}
      getRowHeight={() => "auto"}
    />
  );
};

export default BrandsPlacesTasksTable;
